import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledWithdrawModal = {
  Title: styled.h2`
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    padding-bottom: 16px;
  `,
  InfoBlock: styled.div`
    width: 100%;
    padding-bottom: 16px;
  `,
  InfoRow: styled.p`
    font-size: 16px;
    line-height: 24px;
    color: ${Color.BLUE_DARK};
  `,
  Label: styled.span`
    font-weight: 700;
  `,
  Text: styled.p`
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    color: ${Color.BLUE_DARK};
    padding-bottom: 12px;
  `,
}
